import type React from "react";
import { createContext, type ReactNode } from "react";
import { useNavigate } from "react-router";
import { Loading } from "~/components/Loading";
import type { ResponseError } from "~/error";
import { useSession } from "~/ory/useSession";
import type { Session } from "./Session";

interface Props {
	children: ReactNode;
}

export const SessionContext = createContext<Session | null>(null);

export const SessionProvider: React.FC<Props> = ({ children }) => {
	const navigate = useNavigate();
	const onError = (err: ResponseError): void => {
		switch (err.status) {
			case 403:
				// This is a legacy error code thrown. See code 422 for
				// more details.
				navigate("/login?aal=aal2");
				return;
			case 422:
				// This status code is returned when we are trying to
				// validate a session which has not yet completed
				// its second factor
				navigate("/login?aal=aal2");
				return;
			case 401:
				// do nothing, the user is not logged in
				navigate("/login");
				return;
		}
		console.error(err);
	};

	const [session, isLoading] = useSession(onError);
	if (isLoading) return <Loading />;
	if (!session) return <p>UnAuthenticated</p>;

	return (
		<SessionContext.Provider value={session}>
			{children}
		</SessionContext.Provider>
	);
};
